// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3mHTN","info":"Note_info__2EcCs","note":"Note_note__2U8iJ","actions":"Note_actions__1auvt"};